// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c1d47368","703":"81dd5a8f","787":"532e2eb3"}[chunkId] + ".chunk.js";
};